import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const MerchantReport = () => {
  const { branchId } = useParams();
  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [gridData, setGridData] = useState({
    sumOfCredits: {
      totalDiscount: 0,
      totalTax: 0,
      totalFinalPrice: 0,
      totalPayAmount: 0,
    },
    creditSales: [],
    snappSales: {
      totalDiscount: 0,
      totalTax: 0,
      totalFinalPrice: 0,
    },
    publicSales: {
      totalDiscount: 0,
      totalTax: 0,
      totalFinalPrice: 0,
      totalTipAmount: 0,
      totalPayAmount: 0,
    },
    totalSales: {
      totalDiscount: 0,
      totalTax: 0,
      totalFinalPrice: 0,
      totalTipAmount: 0,
      totalPayAmount: 0,
    },
  });
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    saleUnitId: 0,
    paymentType: 0,
    orderType: 0,
    startDate: methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD"),
    startTime: "",
    endDate: "",
    endTime: "",
    cashDeskId: 0,
    cashierUserId: 0,
    size: 0,
    part: 0,
  });
  const [saleUnits, setSaleUnits] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(branchId);
    if (methods.showApiErrors(resp1)) setSaleUnits(resp1.data);

    const resp2 = await apiMethod.getOrderTypes();
    if (methods.showApiErrors(resp2)) setOrderTypes(resp2.data);

    const resp3 = await apiMethod.getPaymentTypes();
    if (methods.showApiErrors(resp3)) setPaymentTypes(resp3.data);
  };

  const getGridData = async () => {
    const resp = await apiMethod.getMerchantReport(filterModel);
    if (!methods.showApiErrors(resp)) return false;

    setFilterModel({ ...filterModel });
    setGridData(resp.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.saleUnitId = 0;
    filterModel.paymentType = 0;
    filterModel.orderType = 0;
    filterModel.startDate = methods.toPersianDate(Date.now(), "jYYYY/jMM/jDD");
    filterModel.startTime = "";
    filterModel.endDate = "";
    filterModel.endTime = "";
    filterModel.cashDeskId = 0;
    filterModel.cashierUserId = 0;
    filterModel.orderType = 0;
    filterModel.size = 0;
    filterModel.part = 0;
    setFilterModel({ ...filterModel });
    setResetKey((prev) => prev + 1);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const downloadExcelFile = async () => {
    setLoading(true);
    const resp = await apiMethod.getMerchantReportExcel(filterModel);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    window.location = process.env.REACT_APP_ROOT_SALE_API + "/" + resp.data;
  };

  const moduleRender = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/reports/home`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                گزارش فروش مشتری
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>گزارش فروش مشتری</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-2">
                    <label htmlFor="ddlStatuses" className="form-label">
                      بخش های فروش
                    </label>
                    <select
                      id="ddlStatuses"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.saleUnitId}
                      onChange={(e) => {
                        filterModel.saleUnitId = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه بخش ها</option>
                      {saleUnits.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlOrderType" className="form-label">
                      نوع سفارش
                    </label>
                    <select
                      id="ddlOrderType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.orderType}
                      onChange={(e) => {
                        filterModel.orderType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {orderTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-2">
                    <label htmlFor="ddlPaymentType" className="form-label">
                      نوع پرداخت
                    </label>
                    <select
                      id="ddlPaymentType"
                      className="form-select"
                      aria-label="menu"
                      value={filterModel.paymentType}
                      onChange={(e) => {
                        filterModel.paymentType = parseInt(e.target.value);
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه انواع</option>
                      {paymentTypes.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startDate" className="form-label">
                      از تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.startDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.startDate = value.format("YYYY/MM/DD");
                        else filterModel.startDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="startTime" className="form-label">
                      از ساعت
                    </label>
                    <DatePicker
                      key={`startTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker
                          hideSeconds
                          value={filterModel.startTime}
                        />,
                      ]}
                      onChange={(value) => {
                        if (value)
                          filterModel.startTime = value.format("HH:mm");
                        else filterModel.startTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="enddate" className="form-label">
                      تا تاریخ
                    </label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      value={filterModel.endDate}
                      onChange={(value) => {
                        if (value)
                          filterModel.endDate = value.format("YYYY/MM/DD");
                        else filterModel.endDate = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="endTime" className="form-label">
                      تا ساعت
                    </label>
                    <DatePicker
                      key={`startTime-${resetKey}`}
                      disableDayPicker
                      format="HH:mm"
                      plugins={[
                        <TimePicker hideSeconds value={filterModel.endTime} />,
                      ]}
                      onChange={(value) => {
                        if (value) filterModel.endTime = value.format("HH:mm");
                        else filterModel.endTime = "";
                        setFilterModel({ ...filterModel });
                      }}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%",
                      }}
                    />
                  </div>
                </div>
                <div className="mt-3 text-center">
                  <div className="">
                    <button
                      type="button"
                      className="btn btn-purple me-1"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success me-1"
                      onClick={() => {
                        downloadExcelFile();
                      }}
                    >
                      <i className="bi bi-file-earmark-excel"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="shadow p-4">
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-3"></div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <div className="">
                      <table className="table table-bordered table-md mb-4 text-center">
                        <tbody className="align-middle">
                          <tr className="text-center">
                            <td className="bg-light" colSpan={6}>
                              <b>مشتریان اعتباری</b>
                            </td>
                          </tr>
                          <tr>
                            <td>نام مشتری</td>
                            <td>کد مشتری</td>
                            <td>تخفیف</td>
                            <td>مالیات</td>
                            <td>مبلغ فروش</td>
                            <td>مبلغ پرداختی</td>
                          </tr>
                          {gridData.creditSales.map((item, index) => (
                            <tr key={index}>
                              <td>{item.merchantName}</td>
                              <td>{item.merchantCode}</td>
                              <td>
                                {methods.addNumSeperator(item.totalDiscount)}
                              </td>
                              <td>{methods.addNumSeperator(item.totalTax)}</td>
                              <td>
                                {methods.addNumSeperator(item.totalFinalPrice)}
                              </td>
                              <td>
                                {methods.addNumSeperator(item.totalPayAmount)}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td className="bg-dark text-light" colSpan={2}>
                              مجموع مبالغ
                            </td>
                            <td className="bg-light">
                              {methods.addNumSeperator(
                                gridData.sumOfCredits.totalDiscount
                              )}
                            </td>
                            <td className="bg-light">
                              {methods.addNumSeperator(
                                gridData.sumOfCredits.totalTax
                              )}
                            </td>
                            <td className="bg-light">
                              {methods.addNumSeperator(
                                gridData.sumOfCredits.totalFinalPrice
                              )}
                            </td>
                            <td className="bg-light">
                              {methods.addNumSeperator(
                                gridData.sumOfCredits.totalPayAmount
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table table-bordered table-md mb-4">
                        <tbody className="align-middle">
                          <tr className="text-center">
                            <td className="bg-light" colSpan={3}>
                              <b>مشتریان اسنپ</b>
                            </td>
                          </tr>
                          <tr>
                            <td>تخفیف</td>
                            <td>مالیات</td>
                            <td>مبلغ فروش</td>
                          </tr>
                          <tr>
                            <td>
                              {methods.addNumSeperator(
                                gridData.snappSales.totalDiscount
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.snappSales.totalTax
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.snappSales.totalFinalPrice
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table table-bordered table-md mb-4">
                        <tbody className="align-middle">
                          <tr className="text-center">
                            <td className="bg-light" colSpan={5}>
                              <b>مشتریان شعبه</b>
                            </td>
                          </tr>
                          <tr>
                            <td>تخفیف</td>
                            <td>مالیات</td>
                            <td>مبلغ فروش</td>
                            <td>مبلغ انعام</td>
                            <td>مبلغ پرداختی</td>
                          </tr>
                          <tr>
                            <td>
                              {methods.addNumSeperator(
                                gridData.publicSales.totalDiscount
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.publicSales.totalTax
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.publicSales.totalFinalPrice
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.publicSales.totalTipAmount
                              )}
                            </td>
                            <td>
                              {methods.addNumSeperator(
                                gridData.publicSales.totalPayAmount
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3"></div>
                </div>
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return <>{moduleRender()}</>;
};

export default MerchantReport;
